<template lang="pug">
.wrapper
    .container.m-auto
        //- Header Global
        HeaderGlobal(HeaderGlobalHeading="Profile" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Summary Account
            .box__body(style="min-height: 450px")
                .container-form
                    section.group-fields.border-b
                        //- .mb-4.preview-avatar
                            img(:src="photo", alt="alt" @error="getDefaultImage").w-32.h-32.object-cover.rounded-full.border.mx-auto
                            .change-image.relative.mx-auto.btn-primary-o.mt-4
                                input(type="file" @change="changeImgAvatar")
                                span
                                    | Change Image
                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="name") Name *
                            .field__form
                                input.field-style(id="name" name="name" type="text" v-model="name" maxlength="255")
                                .error(v-if="error_name !== null") {{ error_name }}

                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="email") Email *
                            .field__form
                                input.field-style(id="email" name="email" type="email" v-model="email" maxlength="255")
                                .error(v-if="error_email !== null") {{ error_email }}

                        .field.field--disabled
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="role_id") Role
                            .field__form
                                input.field-style(id="role_id" type="text" name="role_id" disabled="disabled" v-model="role_id")

                        .field.field--disabled
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="client_id") Client
                            .field__form
                                input.field-style(id="client_id" type="text" name="client_id" disabled="disabled" v-model="client_id")

                        .field.field--disabled
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="status") Status
                            .field__form
                                input.field-style(id="status" type="text" name="status" disabled="disabled" v-model="status")

                        //- .field
                            label.block.text-sm.font-bold.mb-2(for="fieldError") Role
                            .relative
                                select.field-style
                                    option Opstion A
                                    option(selected) Admin
                                    option Opstion C
                                    option Opstion D
                                .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>

                    section.group-fields.border-b

                        //- .field
                            label.block.text-sm.font-bold.mb-2(for="password") Old Password
                            input.field-style(id="old_password" name="old_password" type="password")
                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="password") Password
                            .field__form
                                input.field-style(id="password" name="password" type="password" v-model="password" maxlength="255")
                                .error(v-if="error_password !== null") {{ error_password }}

                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="password_confirmation") Password Confirmation
                            .field__form
                                input.field-style(id="password_confirmation" name="password_confirmation" type="password" v-model="password_confirmation" maxlength="255")
                                .error(v-if="error_password_confirmation !== null") {{ error_password_confirmation }}

                    .flex.items-center.justify-end.mb-8
                        button.ml-2.btn-default.btn-large(type='button' @click="reset()")
                            | Reset
                        button.ml-2.btn-primary.btn-large(type='submit' @click="submit")
                            | Save

        //- password
        //- .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Password
            .box__body.p-4
                .flex.flex-wrap.-mx-4
                    .block(class="w-1/4").p-4
                    .block(class="w-2/4").p-4
                        form(action="" method="method")
                            .field
                                label.block.text-sm.font-bold.mb-2(for="field") New Password
                                input.field-style(id="field" type="password" placeholder="New Password" v-model="password")

                            .field
                                label.block.text-sm.font-bold.mb-2(for="field") Confirm New Password
                                input.field-style(id="field" type="password" placeholder="Confrim New Password" v-model="password_confirmation")

                            .flex.items-center.justify-between
                                    button.btn-default(type="button") Forgot Password
                                    button.btn-primary.btn-large(type='submit' @click="submitPassword")
                                        Strong Save

                    .block(class="w-1/4").p-4

</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from './../../components/HeaderGlobal.vue'

export default {
    name: 'Profile',
    components: {
        HeaderGlobal
    },
    data() {
        return {
            breadcrumb: [
                {
                    name: 'Profile',
                    url: '/profile',
                },
            ],
            // ImgAvatar: 'https://randomuser.me/api/portraits/men/9.jpg'
            ImgAvatar: this.$store.getters.getDefaultImage,

            photo: '',
            name: '',
            email: '',
            status: '',
            role_id: '',
            client_id: '',
            password: '',
            password_confirmation: '',
            // error field
            error_photo: '',
            error_name: '',
            error_email: '',
            error_status: '',
            error_role_id: '',
            error_password: '',
            error_password_confirmation: '',
        }
    },
    computed: {
        ...mapState([
            'auth_data',
            'load_data_status_users_profile',
            'users_profile',
        ]),
        route_name() {
            return this.$route.name;
        },
        // account() {
        //     // return JSON.parse(localStorage.getItem('auth_data'));
        //     return this.auth_data;
        // },
    },
    watch: {
        route_name() {
            this.getData();
        },
        // account() {},
        users_profile(newData) {
            this.photo = (newData.photo ? newData.photo : '');
            this.name = (newData.name ? newData.name : '');
            this.email = (newData.email ? newData.email : '');
            this.client_id = (newData.client.name ? newData.client.name : '');
            this.role_id = (newData.role.name ? newData.role.name : '');
            this.status = (newData.status ? newData.status : '');


            // console.log('newData')
            // console.table(newData)

            // console.log('this.auth_data')
            // console.table(this.auth_data)

            let tmpAuth = this.auth_data
            try {
                tmpAuth.name = (newData.name ? newData.name : '');
                tmpAuth.email = (newData.email ? newData.email : '');
            } catch (error) {
                console.log('error')
                console.log(error)
            }
            // console.log('tmpAuth')
            // console.table(tmpAuth)
            if (Object.keys(newData).length > 0 && Object.keys(tmpAuth).length > 0)
                this.$store.commit('setAuthData', tmpAuth);
        },
    },
    methods: {
        changeImgAvatar(e) {
            const file = e.target.files[0];
            this.ImgAvatar = URL.createObjectURL(file);
        },
        getDefaultImage(e) {
            e.target.src = this.ImgAvatar;
        },
        getData(update=false) {
            if (this.route_name === 'PageProfile') {
                // console.log(this.route_name)

                this.password = '';
                this.password_confirmation = '';

                if (!update) 
                    this.showLoading(true);

                this.$store.dispatch('getUsersProfile', [this.auth_data.id])
                .then((resp) => {
                    if (resp === 'success') {

                        if (!update) {
                            this.showLoading(false);
                        } else {
                            this.$swal.fire({
                                icon: 'success',
                                title: 'Data successfully updated!',
                                timer: 3000,
                            });
                        }

                    } else {
                        this.error();
                    }
                });
            }
        },
        validateEmail(email) {
            /* eslint-disable no-useless-escape */
            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        reset() {
            this.$swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to reset form?',
                // text: id,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                if (result.isConfirmed) {
                    this.getData();
                }
            });
        },
        submit(e){
            e.preventDefault();

            this.showLoading(true);

            this.error_photo = '';
            this.error_name = '';
            this.error_email = '';
            this.error_status = '';
            this.error_role_id = '';
            this.error_password = '';
            this.error_password_confirmation = '';

            if (this.name.length==0 || this.email.length==0) {

                this.error_name = (this.name.length==0 ? 'Field name is required.' : '');
                this.error_email = (this.email.length==0 ? 'Field email is required.' : '');

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data is required!',
                    text: 'Name & email is required!',
                    // timer: 3000,
                });

                return;
            }

            if (this.name.length>255 || this.email.length>255 || this.password.length>255 || this.password_confirmation.length>255) {

                // this.error_photo = (this.photo.length>255 ? 'Field photo is not more than 255 characters.' : '');
                this.error_name = (this.name.length>255 ? 'Field name is not more than 255 characters.' : '');
                this.error_email = (this.email.length>255 ? 'Field email is not more than 255 characters.' : '');
                // this.error_status = (this.status.length>255 ? 'Field status is not more than 255 characters.' : '');
                // this.error_role_id = (this.role_id.length>255 ? 'Field role is not more than 255 characters.' : '');

                this.error_password = (this.password.length>255 ? 'Field password is not more than 255 characters.' : '');
                this.error_password_confirmation = (this.password_confirmation.length>255 ? 'Field password confirmation is not more than 255 characters.' : '');

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data length is not more than 255 characters!',
                    text: 'Name, email, password, & password confirmation is not allowed more than 255 characters!',
                    // timer: 3000,
                });

                return;
            }

            if (!this.validateEmail(this.email)) {
                this.error_email = 'The email must be a valid email address.';

                this.$swal.fire({
                    title: 'Email must be a valid email address.',
                    icon: 'warning',
                    // timer: 3000,
                });
                return;
            }

            if (this.password.length > 0 || this.password_confirmation.length > 0) {

                if (this.password !== this.password_confirmation) {

                    this.error_password_confirmation = 'Password confirmation is not match.';

                    this.$swal.fire({
                        icon: 'warning',
                        title: 'Password confirmation is not match!',
                        text: 'Password & password confirmation  is not match!',
                        // timer: 3000,
                    });

                    return;
                }
            }

            // this.$store.dispatch('getUsersUpdate', [this.account.id, this.name, this.email, this.client_id, this.role_id, (this.status.toLowerCase() === 'active' ? 1 : 0)])

            // console.log('updated profile')
            // console.log(this.auth_data.status)

            this.$store.dispatch('getUsersProfileUpdate', [this.auth_data.id, this.name, this.email, this.auth_data.role.id, (this.auth_data.status === 'active' || this.auth_data.status === 'Active' || this.auth_data.status === '1' || this.auth_data.status === 1 ? '1' : '0'), this.password])
            .then((resp) => {
                if (resp.result === 'success') {

                    this.getData(true);

                    // this.password = '';
                    // this.password_confirmation = '';

                    // -> NEED TESTING!!!!
                    // if (Object.keys(this.users_profile).length > 0)
                    //     this.$store.commit('setAuthData', this.users_profile);

                    // this.$swal.fire({
                    //     icon: 'success',
                    //     title: 'Data successfully updated!',
                    //     timer: 3000,
                    // });

                } else {
                    if (resp.data.message && resp.data.message.errors) {
                        // this.error_photo = (resp.data.message.errors.photo ? resp.data.message.errors.photo : '');
                        this.error_name = (resp.data.message.errors.name ? resp.data.message.errors.name : '');
                        this.error_email = (resp.data.message.errors.email ? resp.data.message.errors.email : '');
                        // this.error_status = (resp.data.message.errors.status ? resp.data.message.errors.status : '');
                        // this.error_role_id = (resp.data.message.errors.role_id ? resp.data.message.errors.role_id : '');
                        this.error_password = (resp.data.message.errors.password ? resp.data.message.errors.password : '');
                        // this.error_password_confirmation = (resp.data.message.errors.password_confirmation ? resp.data.message.errors.password_confirmation : '');

                        this.error(resp.data.message, resp.data.message.errors);
                    } else {
                        this.error();
                    }
                }
            });
        },
        // not used
        // submitPassword(e){
        //     e.preventDefault();

        //     console.log('submit password')

        //     if (this.password.length==0 || this.password_confirmation.length==0) {

        //         this.$swal.fire({
        //             icon: 'warning',
        //             title: 'Data is required!',
        //             text: 'Password & password confirmation is required!',
        //             // timer: 3000,
        //         });

        //         return;
        //     }

        //     if (this.password !== this.password_confirmation) {

        //         this.$swal.fire({
        //             icon: 'error',
        //             title: 'Data is required!',
        //             text: 'Password & password confirmation not match!',
        //             // timer: 3000,
        //         });

        //         return;
        //     }

        //     this.showLoading(true);

        //     this.$store.dispatch('getUsersUpdate', [this.account.id, this.name, this.email, this.client_id, this.role_id, (this.status.toLowerCase() === 'active' ? 1 : 0), this.password])
        //     .then((resp) => {
        //         if (resp === 'success') {

        //             this.$swal.fire({
        //                 icon: 'success',
        //                 title: 'Data successfully updated!',
        //                 timer: 3000,
        //             });
        //         } else {
        //             this.error();
        //         }
        //     });
        // },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(message=null, data=null) {
            let errors = '';

            if (data !== null) {
                Object.keys(data).forEach(function (item) {
                    errors += data[item] + '<br><br>';
                    // errors += '<div class="swal2-html-container" style="display: block;">' + data[item] + '<div>';
                });
            }

            this.$swal.fire({
                icon: 'error',
                title: 'Failed!',
                text: (message? message : 'Something wrong.'),
                html: errors,
                // timer: 3000
            });
        },
    },
    mounted() {
        this.getData();
    },
}
</script>

<style lang="sass">
.preview-avatar
    text-align: center
    .change-image
        input
            position: absolute
            top: 0
            left: 0
            right: 0
            bottom: 0
            width: 100%
            height: 100%
            cursor: pointer
            opacity: 0
</style>


